import api from './api'
import cache from '@/utils/cache'

export default {
  getPersonStatuses: cache('getPersonStatuses', () => api.codeListService.getCodeList('PersonStatus')),
  getBankStates: cache('getBankStates', () => api.codeListService.getCodeList('BankState')),
  getCompanyStates: cache('getCompanyStates', () => api.codeListService.getCodeList('CompanyState')),
  getCountries: cache('countries', () => api.codeListService.getCodeList('Country')),
  getGenders: cache('genders', () => api.codeListService.getCodeList('Gender')),
  getRegions: cache('regions', () => api.codeListService.getCodeList('Region')),
  getProvinces: cache('provinces', () => api.codeListService.getCodeList('Province')),
  getTownships: cache('townships', () => api.codeListService.getCodeList('Township')),
  getDistricts: cache('districts', () => api.codeListService.getCodeList('District')),
  getAddressTypes: cache('addressTypes', () => api.codeListService.getCodeList('AddressType')),
  getResidentialUnitTypes: cache('residentialUnitTypes', () => api.codeListService.getCodeList('ResidentialUnitType')),
  getPersonalIdTypes: cache('personalIdTypes', () => api.codeListService.getCodeList('PersonalIdType')),
  getContactInformationTypes: cache('contactInformationTypes', () => api.codeListService.getCodeList('ContactInformationType')),
  getBanTypes: cache('banTypes', () => api.codeListService.getCodeList('BanType')),
  getRelatedPersonTypes: cache('getRelatedPersonTypes', () => api.codeListService.getCodeList('RelatedPersonType')),
  getOrganizationalUnitType: cache('organizationalUnitType', () => api.codeListService.getCodeList('OrganizationalUnitType')),
  getBankTypes: cache('bankTypes', () => api.codeListService.getCodeList('BankType')),
  getCompanyTypes: cache('getCompanyTypes', () => api.codeListService.getCodeList('CompanyType')),
  getCompanySubtypes: cache('getCompanySubtypes', () => api.codeListService.getCodeList('CompanySubtype')),
  getBranchTypes: cache('getBranchTypes', () => api.codeListService.getCodeList('BranchType')),
  getOwnershipTypes: cache('OwnershipTypes', () => api.codeListService.getCodeList('OwnershipType')),
  getPropertyTypes: cache('PropertyTypes', () => api.codeListService.getCodeList('PropertyType')),
  getIncorporationStates: cache('IncorporationState', () => api.codeListService.getCodeList('IncorporationState')),
  getLicenseTypes: cache('getLicenseTypes', () => api.codeListService.getCodeList('LicenseType')),
  getResponsibilityTypes: cache('getResponsibilityTypes', () => api.codeListService.getCodeList('ResponsibilityType')),
  getJobTitles: cache('jobTitles', () => api.codeListService.getCodeList('JobPosition')),
  getBankCapitalOperationTypes: cache('BankCapitalOperationTypes', () => api.codeListService.getCodeList('BankCapitalOperationType')),
  getMembershipTypes: cache('getMembershipTypes', () => api.codeListService.getCodeList('MembershipType')),
  getDegreesOfMembership: cache('getDegreesOfMembership', () => api.codeListService.getCodeList('DegreeOfMembership')),
  getBanksLookup: cache('banksLookup', () => api.bankService.getLookupAll())
}



// WEBPACK FOOTER //
// ./src/report-app/cached.js